// extracted by mini-css-extract-plugin
module.exports = {"container":"BidRow_container__CTGEO","usdPrice":"BidRow_usdPrice__1HK2w","infoIcon":"BidRow_infoIcon__35HJm"};